export { default } from './GachaItemDetail';
